import React, { useState } from "react";
import { useSelector } from "react-redux";

function PartnerServices() {
  const langue = useSelector((state) => state.langue.value); // Langue actuelle

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const TELEGRAM_BOT_TOKEN = import.meta.env.VITE_TELEGRAM_BOT_TOKEN;
  const CHAT_ID = import.meta.env.VITE_TELEGRAM_CHAT_ID;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const message = `
📩 *Nouvelle Demande de Partenariat* 📩

👤 *Nom:* ${formData.name}
✉️ *Email:* ${formData.email}
🏢 *Entreprise:* ${formData.company}
📝 *Message:* ${formData.message}
    `;

    try {
      const response = await fetch(
        `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            chat_id: CHAT_ID,
            text: message,
            parse_mode: "Markdown",
          }),
        }
      );

      if (response.ok) {
        alert(langue === "fr" ? "✅ Demande envoyée avec succès !" : "✅ تم إرسال الطلب بنجاح!");
        setFormData({ name: "", email: "", company: "", message: "" });
      } else {
        alert(langue === "fr" ? "❌ Erreur lors de l'envoi de la demande !" : "❌ حدث خطأ أثناء إرسال الطلب!");
      }
    } catch (error) {
      alert(langue === "fr" ? "⚠️ Impossible d'envoyer la demande." : "⚠️ تعذر إرسال الطلب.");
    }
  };

  return (
    <div className="containerw-full mx-auto p-6 bg-gray-300">
      <h1 className="text-3xl font-bold text-center mb-6 text-green-800">
        {langue === "fr" ? "Services pour les Partenaires" : "خدمات للشركاء"}
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        <div className="bg-gray-200 p-4 shadow-md rounded-lg">
          <h2 className="text-lg font-semibold">📦 {langue === "fr" ? "Fourniture d'épices en gros" : "توفير التوابل بالجملة"}</h2>
          <p className="text-gray-500">
            {langue === "fr" 
              ? "Accédez à nos produits en gros avec des prix exclusifs pour nos partenaires."
              : "احصل على منتجاتنا بالجملة بأسعار حصرية لشركائنا."
            }
          </p>
        </div>
        <div className="bg-gray-200 p-4 shadow-md rounded-lg">
          <h2 className="text-lg font-semibold">🚚 {langue === "fr" ? "Livraison rapide" : "تسليم سريع"}</h2>
          <p className="text-gray-500">
            {langue === "fr" 
              ? "Bénéficiez d'une logistique optimisée pour une livraison rapide et fiable."
              : "استفد من لوجستيات متطورة للتسليم السريع والموثوق."
            }
          </p>
        </div>
        <div className="bg-gray-200 p-4 shadow-md rounded-lg">
          <h2 className="text-lg font-semibold">📈 {langue === "fr" ? "Marketing & Promotion" : "التسويق والترويج"}</h2>
          <p className="text-gray-700">
            {langue === "fr" 
              ? "Profitez de notre réseau pour augmenter la visibilité de vos produits."
              : "استفد من شبكتنا لزيادة رؤية منتجاتك."
            }
          </p>
        </div>
      </div>

      <div className="bg-gray-200 p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold mb-4 text-center">
          {langue === "fr" ? "🤝 Devenir Partenaire" : "🤝 أن تصبح شريكًا"}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            name="name"
            placeholder={langue === "fr" ? "Nom complet" : "الاسم الكامل"}
            value={formData.name}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
            required
          />
          <input
            type="email"
            name="email"
            placeholder={langue === "fr" ? "Email professionnel" : "البريد الإلكتروني المهني"}
            value={formData.email}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
            required
          />
          <input
            type="text"
            name="company"
            placeholder={langue === "fr" ? "Nom de l'entreprise" : "اسم الشركة"}
            value={formData.company}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
            required
          />
          <textarea
            name="message"
            placeholder={langue === "fr" ? "Expliquez votre projet ou votre besoin..." : "اشرح مشروعك أو حاجتك..."}
            value={formData.message}
            onChange={handleChange}
            className="w-full p-2 border rounded-md h-32"
            required
          />
          <button
            type="submit"
            className="bg-green-600 text-white px-4 py-2 rounded-md w-full hover:bg-green-700 transition"
          >
            {langue === "fr" ? "Envoyer la demande" : "إرسال الطلب"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default PartnerServices;
